import React, {ChangeEvent, FC, useState} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {InputGroup} from "react-bootstrap";
import {useImageUploadController} from "../../../controllers/useImageUploadController";
import ToolTip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {useParams} from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

interface PropsType {
    id: string;
    value: string;
    handleOnChange: (value: string) => void;
    dataTestId?: string;
}

export const ImagesInput: FC<PropsType> = ({id, value, handleOnChange, ...props}) => {

    const controller = useImageUploadController();
    const routeParams = useParams<{ projectId: string }>();
    const [filesSelected, setFilesSelected] = useState<File[]>([] as File[]);
    const [filesUploaded, setFilesUploaded] = useState(!!value);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [returnedFilePaths, setReturnedFilePaths] = useState<string>(value);

    const saveSelectedFiles = (e: ChangeEvent<HTMLInputElement>) => {

        if (e.target.files != null) {
            for (let i = 0; i < e.target.files.length; i++) {

                const newSelectedFilesList = filesSelected;

                newSelectedFilesList.push(e.target.files[i]);

                setFilesSelected(newSelectedFilesList);
            }
        }
    }

    const uploadFiles = async () => {

        if (filesSelected.length > 0) {

            setUploadInProgress(true);

            const responsePaths = [];

            for (let i = 0; i < filesSelected.length; i++) {

                // routeParams.projectId should never be null at this point. Not sure why it's suggesting it is here, and elsewhere it isn't. Type assertion added to hide warning.
                const uploadImageRequest = await controller.handleImageUpload(filesSelected[i], routeParams.projectId as string);

                if (uploadImageRequest.uploadSucceeded && uploadImageRequest.res !== null) {
                    responsePaths.push(uploadImageRequest.res.data.path);
                } else {
                    setFilesUploaded(false);
                    setUploadInProgress(false);
                    return;
                }
            }

            setUploadInProgress(false);
            setReturnedFilePaths(responsePaths.toString());
            setFilesUploaded(true);
            handleOnChange(responsePaths.concat().toString());
        }
    }

    const editImage = () => {
        setFilesUploaded(false);
        setFilesSelected([]);
    }

    if (filesUploaded) {
        return <InputGroup className="mb-3">
            <Form.Control type="text"
                          id={id}
                          value={returnedFilePaths.toString()}
                          disabled
            />
            <Button variant="success" id="button-addon1" onDoubleClick={editImage}><i
                className='fas fa-check'/></Button>
        </InputGroup>
    } else {
        return <>
            <OverlayTrigger placement="top" overlay={
                <ToolTip id="button-tooltip">Files will be uploaded first when you press the upload button. The remote
                    path will then be saved as the entity property value. You must upload the image before saving the
                    entity.</ToolTip>}>
                <span className="m-1"><i className={`fa fa-info-circle`}/></span>
            </OverlayTrigger>
            <InputGroup className="mb-3">
                <Form.Control type="file"
                              id={"blah"}
                              onChange={saveSelectedFiles}
                              accept=".png,.jpeg,.jpg,.gif"
                              multiple
                              {...props} />
                <Button variant="success" id="button-addon1"
                        onClick={uploadFiles}>
                    {uploadInProgress ? <Spinner animation="border" role="status"/> : <i className='fas fa-upload'/>}
                </Button>
            </InputGroup>

        </>
    }
};
